import { render, staticRenderFns } from "./adminCancelBtn.vue?vue&type=template&id=22044ba1&scoped=true"
import script from "./adminCancelBtn.vue?vue&type=script&lang=js"
export * from "./adminCancelBtn.vue?vue&type=script&lang=js"
import style0 from "./adminCancelBtn.vue?vue&type=style&index=0&id=22044ba1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22044ba1",
  null
  
)

export default component.exports